const cleanId = (value) => typeof value === "string" ? value.trim() : "";

// A project reference takes precedence over legacy opportunity/quote aliases.
export function resolveTaskTarget(input = {}) {
  const task = { ...input, ...(input.crmTask || input.original || {}) };
  const type = String(task.relatedType || "").toLowerCase();
  const relatedId = cleanId(task.relatedId);
  const projectId = cleanId(task.projectId || task.trackingTaskForProjectId ||
    task.paymentFollowUpForProjectId || task.installationForProjectId) ||
    (["project", "order", "project_tracking", "project_payment"].includes(type) ? relatedId : "");
  if (projectId) return { type: "project", id: projectId, label: "Open Order" };
  if (type === "customer" && relatedId) {
    return { type: "customer", id: relatedId, label: "Open Customer" };
  }
  if (["quote", "quotation"].includes(type) && (relatedId || cleanId(task.quoteId))) {
    return { type: "quotation", id: relatedId || cleanId(task.quoteId), label: "Open Quotation" };
  }
  if (type === "opportunity" && relatedId) {
    return { type: "opportunity", id: relatedId, label: "Open Deal" };
  }
  const dealId = cleanId(task.crmLeadId || task.leadId || task.dealId) ||
    (["lead", "crm_lead", "deal"].includes(type) ? relatedId : "");
  if (dealId) return { type: "deal", id: dealId, label: "Open Deal" };
  if (type === "opportunity" || cleanId(task.opportunityId)) {
    const id = (type === "opportunity" ? relatedId : "") || cleanId(task.opportunityId);
    if (id) return { type: "opportunity", id, label: "Open Deal" };
  }
  const quoteId = cleanId(task.quoteId) ||
    (["quote", "quotation"].includes(type) ? relatedId : "");
  if (quoteId) return { type: "quotation", id: quoteId, label: "Open Quotation" };
  const customerId = cleanId(task.customerId);
  if (customerId) return { type: "customer", id: customerId, label: "Open Customer" };
  return { type: "standalone", id: "", label: "Task details" };
}

export function isUnavailableTaskTarget(record = {}) {
  return record.deleted === true || record.archived === true ||
    ["deleted", "archived", "in_bin"].includes(record.binStatus) ||
    ["deleted", "archived", "bin"].includes(record.visibilityStatus);
}
